import React from 'react';
import InvitationEvaluationTable from './InvitationEvaluationTable';

const ProductHydroTable = ({ refreshTrigger, exportName }) => (
  <InvitationEvaluationTable
    procurementTypeHeader='1'
    refreshTrigger={refreshTrigger}
    exportName={exportName}
  />
);

export default React.memo(ProductHydroTable);
